module.exports = __webpack_public_path__ + "img/zhurkovich.02b8c9bc.png";